import { Graph, INode } from '@yfiles/yfiles';
import { IGraphAdapter, IGraphNode } from './graphInterfaces';

/**
 * Adapter to make yFiles Graph compatible with IGraphAdapter interface
 */
export class YFilesGraphAdapter implements IGraphAdapter {
  constructor(private readonly graph: Graph) {}

  get nodes(): Iterable<IGraphNode> {
    return this.graph.nodes as Iterable<IGraphNode>;
  }

  getChildren(node: IGraphNode): Iterable<IGraphNode> {
    return this.graph.getChildren(node as INode) as Iterable<IGraphNode>;
  }

  contains(node: IGraphNode): boolean {
    return this.graph.contains(node as INode);
  }
}
